import { PersistedWorkflow } from '@cotera/sdk/core';
import { parseToolCallParamBindingRef } from '@cotera/utilities';

const { isNodeScopedFieldPath } = PersistedWorkflow;

/**
 * Renders a stored field path for a node card.
 *
 * A bare pointer shows as-is. A `Node/pointer` reference resolves its source
 * through `sourceLabels` so the card shows the friendly name the "/" picker
 * showed (e.g. `Gen Z Generator/name`) rather than the raw stored key.
 *
 * Shared by every card that displays one upstream field, so a filter condition
 * and a debounce key can never describe the same path differently.
 */
export function describeFieldPath(
  path: string,
  sourceLabels: ReadonlyMap<string, string>
): string {
  if (path === '') {
    return '(value)';
  }
  if (!isNodeScopedFieldPath(path)) {
    return path;
  }
  try {
    const { sourceName, pointer } = parseToolCallParamBindingRef(path);
    if (sourceName === undefined) {
      return path;
    }
    return `${sourceLabels.get(sourceName) ?? sourceName}${pointer}`;
  } catch {
    return path;
  }
}
